module.exports = __webpack_public_path__ + "img/logofs.f96d435b.svg";